<template>
  <div class="userListPage">
    <div class="head flex-rowl">
      <div class="icon"><i class="iconfont icon-tianjiaqunzu_huaban1"></i></div>
      <div class="con">
        <div class="txt1">成员管理</div>
        <div class="txt2">企业/团队成员管理</div>
      </div>
    </div>

    <van-sticky>
      <div class="my_tabs_head flex-between">
        <div
          class="my_tans_list"
          :class="{ active: tabActive == 0 }"
          @click="handleTabs(0)"
        >
          人员管理
        </div>
        <div
          class="my_tans_list"
          :class="{ active: tabActive == 1 }"
          @click="handleTabs(1)"
        >
          加入申请
        </div>
      </div>
    </van-sticky>

    <div class="my_tabs_body">
      <div class="my_tabs_list" v-if="tabActive == 0">
        <div class="my_tab_item" v-for="item in tabListOne" :key="item.id">
          <div
            class="main_wrap flex-rowl"
            @click="handleDetail(item.openid, item.id)"
          >
            <div class="tx flex-rowc">
              <van-image
                :src="item.user.headimg"
                width="100%"
                height="100%"
                round
                v-if="item.user.headimg && item.user.headimg != ''"
              />
              <i class="iconfont icon-touxiang" v-else></i>
            </div>
            <div class="main">
              <!-- <div class="nick">{{ item.user.nickname }}</div> -->
              <div class="name">{{ item.user.truename }}</div>
              <div class="leavel_accounId flex-rowl">
                <div class="leavel">
                  LV-{{ item.user.levelid }} <span>|</span>
                  {{ item.user.attrname }}
                </div>
                <!-- <div class="leavel">ID:{{ item.accountid }}</div> -->
              </div>
              <div class="txt">手机号：{{ formatPhone(item.mobile) }}</div>
              <div class="txt">所属部门：{{ item.deptname }}</div>
              <div class="txt">角色关系：{{ item.rolename }}</div>
            </div>
          </div>
          <div class="more_wrap flex-rowr">
            <div class="more_icon flex-rowc">
              <i class="iconfont icon-yuyinjiantou"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="my_tabs_list" v-if="tabActive == 1">
        <div class="my_tab_item" v-for="item in tabListTwo" :key="item.id">
          <div
            class="main_wrap flex-rowl"
            @click="handleDetail(item.openid, item.id)"
          >
            <div class="tx flex-rowc">
              <van-image
                :src="item.user.headimg"
                width="100%"
                height="100%"
                round
                v-if="item.user.headimg && item.user.headimg != ''"
              />
              <i class="iconfont icon-touxiang" v-else></i>
            </div>
            <div class="main">
              <!-- <div class="nick">{{ item.user.nickname }}</div> -->
              <div class="name">{{ item.user.truename }}</div>
              <div class="leavel_accounId flex-rowl">
                <div class="leavel">
                  LV-{{ item.user.levelid }} <span>|</span>
                  {{ item.user.attrname }}
                </div>
                <div class="leavel">ID:{{ item.accountid }}</div>
              </div>
              <div class="time_more flex-between">
                <div class="time">申请时间：{{ item.joinDate }}</div>
                <div class="more flex-rowc">
                  <i class="iconfont icon-gengduo"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>
<script>
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getApplyCompanyList } from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "userList",
  data() {
    return {
      tabListOne: [],
      tabListTwo: [],
      tabActive: 0,
      qyid: ''
    };
  },
   computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.qyid = qyid;
        this.getApplyCompanyList();
      } else {
        this.$router.back();
      }
    },

    handleTabs(index) {
      this.tabActive = index;
    },
    // 手机号隐藏四位
    formatPhone(mobile) {
      const phone = mobile;
      let hiddenPhone = "";

      if (phone.length === 11) {
        hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      }

      return hiddenPhone;
    },
    getApplyCompanyList() {
      let { qyid } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getApplyCompanyList({ qyid }).then((res) => {
        res.forEach((v) => {
          v.joinDate =
            v.checkdate.split("T")[0] + " " + v.checkdate.split("T")[1];
          if (v.checkstate == 1) {
            this.tabListOne.push(v);
          }
          if (v.checkstate == 0) {
            this.tabListTwo.push(v);
          }
        });
        toast.clear();
      });
    },

    handleDetail(openid, id) {
      let { qyid } = this;
      // this.$router.push(`/companyIndex/userDetail/${openid}/${qyid}/${id}`);
      // this.$router.push({ name: "userDetail", params: { openid, qyid, id } });
      this.encryptstringadd('userDetail', {openid, qyid, id})
    },

     // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.userListPage {
  background: #fafafa;
  padding-bottom: 250px;
  min-height: 100vh;
  box-sizing: border-box;
  .icon-touxiang {
    font-size: 60px;
  }
  .head {
    padding: 100px 75px 30px;
    font-size: 30px;
    color: #333333;
    .icon .icon-tianjiaqunzu_huaban1 {
      font-size: 47px;
      margin-right: 16px;
    }
    .txt2 {
      font-size: 20px;
      margin-top: 7px;
    }
  }
  .my_tabs_head {
    height: 150px;
    background: #fff;
    margin-bottom: 30px;
    .my_tans_list {
      height: 100%;
      flex: 1;
      text-align: center;
      line-height: 150px;
      font-size: 30px;
      color: #333333;
      position: relative;
      &.active::after {
        display: inline-block;
        content: "";
        height: 10px;
        background-color: #373737;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
  .my_tabs_body {
    .my_tab_item {
      background: #fff;
      margin-bottom: 10px;
      padding: 40px 50px 34px 60px;
      box-sizing: border-box;
      .main_wrap {
        align-items: flex-start;
        .tx {
          width: 120px;
          height: 120px;
          flex-shrink: 0;
          border-radius: 50%;
          background: #eae9ef;
          border: 1px solid #504f5e;
          margin-right: 38px;
          .icon-touxiang {
            color: #504f5e;
            font-size: 120px;
          }
        }
        .main {
          flex: 1;
          .name {
            font-size: 30px;
            color: #3c3c3c;
          }
          .nick {
            font-size: 22px;
            color: #828282;
            margin: 15px 0 18px;
          }
          .leavel_accounId {
            font-size: 16px;
            color: #aaaaaa;
            margin: 5px 0 29px;
          }
          .leavel {
            margin-right: 39px;
          }
        }
      }
      .txt {
        font-size: 24px;
        color: #333333;
        margin-bottom: 12px;
      }
      .time_more {
        font-size: 22px;
        color: #333333;
      }
      .more {
        width: 70px;
        height: 35px;
        border: 1px solid #c8c8c8;
        border-radius: 20px;
      }
      .more_icon {
        width: 70px;
        height: 35px;
        border: 1px solid #c8c8c8;
        border-radius: 20px;
        .icon-yuyinjiantou {
          transform: rotate(-90deg);
        }
      }
    }
  }
  .custom_btn {
    margin-top: 150px;
  }
}
</style>